import { Avatar } from 'antd';
import ColorHash from 'color-hash';
import PrevTaskCard from './PrevTaskCard';

const colorHash = new ColorHash({ lightness: 0.7 });

export default function TaskByEmployee({ plan, onRefresh }) {
  const UserAvatar = ({ user }) => {
    const initials =
      String(user.first_name).charAt(0) + String(user.last_name).charAt(0);
    return (
      <div className="flex items-center gap-2">
        <Avatar
          style={{
            backgroundColor: colorHash.hex(initials)
          }}
        >
          {initials}
        </Avatar>
        <label className="!text-sm font-semibold text-gray-600">
          {`${user.first_name} ${user.last_name}`}
        </label>
      </div>
    );
  };

  return (
    <div className="grid grid-cols-1 gap-4 md:grid-cols-[1fr_4fr] place-items-start bg-gray-50 p-2 md:p-4 rounded-lg">
      <UserAvatar user={plan?.user} />
      <div className="flex flex-col w-full gap-4">
        {plan.tasks.map((task) => {
          return (
            <PrevTaskCard
              key={task.id}
              type={task.task_status}
              onRefresh={onRefresh}
              data={{
                title: task.task.title,
                description: task.task.description,
                client: {
                  client_name: task.task.client.client_name
                },
                project: {
                  project: task.task.project.project
                },
                id: task.task.id,
                isHighlighted: task.is_highlight,
                isReleased: task.plan_released,
                plan_id: task.id
              }}
            />
          );
        })}
      </div>
    </div>
  );
}
